import { useContext, useMemo } from "react";
import StreamingRoyaltiesPresenter from "./StreamingRoyaltiesPresenter";
import { useServiceEarningsQuery, useSongEarningsQuery } from "../../../api/earnings";
import { orderBy } from "lodash";
import AppContext from "src/AppContext";
import UnavailableContent from "@arelia-components/ui-atoms/UnavailableContent";
import { Box } from "@mui/material";
import { SubscriptionPlanName } from "@arelia-types/subscriptions";

export default function StreamingRoyaltiesContainer() {
  const songQuery = useSongEarningsQuery();
  const serviceQuery = useServiceEarningsQuery();
  const { account } = useContext(AppContext);

  const songEarnings = useMemo(() => orderBy(songQuery.data, x => x.earning, 'desc'), [songQuery.data]);
  const serviceEarnings = useMemo(() => orderBy(serviceQuery.data, x => x.earning, 'desc'), [serviceQuery.data]);

  return account?.plan === SubscriptionPlanName.Starter
    ? <Box sx={{ height: "300px" }}>
        <UnavailableContent message="To have an access to Streaming Royalties Details upgrade to My Social" />
      </Box>
    : <StreamingRoyaltiesPresenter
      songEarnings={songEarnings}
      serviceEarnings={serviceEarnings}
      loadingSongs={songQuery.isLoading}
      loadingServices={serviceQuery.isLoading}
    />;
}
